import { isNil, isEmpty, size, isFunction } from 'lodash';
import ServiceUrls from '@/lib/ServiceUrls';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { TimelineMax, TweenMax } from 'gsap';
import FilterMixin from './FilterMixin';
import HotelSettingsMixin from './HotelSettingsMixin';
import LocaleMixin from './LocaleMixin';

// define a mixin object
export default {
  props: ['lang', 'primaryLanguage'],

  methods: {
    setUserConfig: function (key, val, global = false) {
      localStorage.setItem(`${this.$root.hotel}__${this.$root.username}__${global ? 'global' : this.$options.name}__${key}`, val);
    },
    getUserConfig: function (key, global = false) {
      return localStorage.getItem(`${this.$root.hotel}__${this.$root.username}__${global ? 'global' : this.$options.name}__${key}`);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/UserConfigMixin.js